import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { EsgIndicatorGridDto } from '../../services/types/EsgIndicators';
import IndicatorBadge from './Operation/Indicator/IndicatorTimeline/IndicatorBadge';

interface Props {
  dto: EsgIndicatorGridDto;
}

const renderSpr = (value: string) => {
  if (value && value.length > 0) {
    return <IndicatorBadge value={value.substring(1)} typeCode="" />;
  }
  return 'Not Set';
};

const setValue = (value: string, type: string) => {
  if (value && value.length > 0) {
    let content;

    if (type === 'SprRating') {
      content = renderSpr(value);
    } else {
      content = value;
    }

    if (type === 'Hazards') {
      content = (
        <div className="badge-base-indicator badge-base-indicator-clip" title={value}>
          <span>
            <FontAwesomeIcon icon="clipboard-list" />
          </span>
        </div>
      );
    }
    return content;
  }

  return 'Not Set';
};

const noData = 'Not available';

const IndicatorGridValue: React.FC<Props> = ({ dto }) => (
  <tr className="grid-cell" key={`indicator_tr_${dto.id}`}>
    <td title={dto.description}>{dto.name}</td>
    <td>
      {dto.enabled ? (
        <>{setValue(dto.value, dto.typeValue)}</>
      ) : (
        <FontAwesomeIcon
          className="no-data-icon"
          icon="ban"
          style={{ width: '18px', height: '18px' }}
          title={noData}
        />
      )}
    </td>
  </tr>
);

export default IndicatorGridValue;
